import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";

type TabType = "fan" | "artist";

const fanPlans = [
  {
    id: "free",
    name: "Free",
    nameKo: "무료",
    price: 0,
    color: "#aaaaaa",
    gradient: "from-white/8 to-transparent",
    border: "border-white/15",
    badge: null as string | null,
    tokens: 10,
    tokenLabel: "10 토큰/월",
    features: [
      "월 10 AI 생성 토큰 제공",
      "기본 퀘스트 참여",
      "커뮤니티 피드 열람",
      "아이돌 IP 1종 접근",
      "영상 해상도 720p",
      "커뮤니티 좋아요/댓글",
    ],
    limits: ["고급 퀘스트 제한", "HD 영상 불가", "토큰 이월 불가"],
    cta: "무료로 시작",
    ctaLink: "/signup?plan=free",
  },
  {
    id: "fan",
    name: "Fan",
    nameKo: "팬",
    price: 9900,
    color: "#ff6eb4",
    gradient: "from-[#ff6eb4]/15 to-transparent",
    border: "border-[#ff6eb4]/40",
    badge: "인기" as string | null,
    tokens: 100,
    tokenLabel: "100 토큰/월",
    features: [
      "월 100 AI 생성 토큰 제공",
      "모든 퀘스트 참여 가능",
      "전체 아이돌 IP 접근",
      "영상 해상도 1080p",
      "토큰 최대 50개 이월",
      "에디터 픽 선정 자격",
      "우선 고객 지원",
      "월간 보너스 토큰 10개",
    ],
    limits: [],
    cta: "팬 플랜 시작",
    ctaLink: "/signup?plan=fan",
  },
  {
    id: "superfan",
    name: "Super Fan",
    nameKo: "슈퍼팬",
    price: 24900,
    color: "#4fc3f7",
    gradient: "from-[#4fc3f7]/15 to-transparent",
    border: "border-[#4fc3f7]/40",
    badge: "최고 혜택" as string | null,
    tokens: 300,
    tokenLabel: "300 토큰/월",
    features: [
      "월 300 AI 생성 토큰 제공",
      "모든 퀘스트 무제한 참여",
      "전체 아이돌 IP + 독점 IP 접근",
      "영상 해상도 4K",
      "토큰 무제한 이월",
      "에디터 픽 우선 선정",
      "아이돌 팬미팅 추첨 자격",
      "월간 보너스 토큰 50개",
      "전용 슈퍼팬 배지",
      "신규 퀘스트 얼리 액세스",
    ],
    limits: [],
    cta: "슈퍼팬 플랜 시작",
    ctaLink: "/signup?plan=superfan",
  },
];

const artistPlans = [
  {
    id: "artist-starter",
    name: "Starter",
    nameKo: "스타터",
    price: 29900,
    color: "#ffd60a",
    gradient: "from-[#ffd60a]/12 to-transparent",
    border: "border-[#ffd60a]/35",
    badge: null as string | null,
    questLimit: 3,
    questLabel: "월 3개 캠페인 생성",
    features: [
      "아티스트 공식 프로필 페이지 생성",
      "월 3개 캠페인 출제",
      "IP 이미지 최대 4종 등록",
      "팬 제출 영상 열람",
      "기본 팬 참여 통계",
      "커뮤니티 공지 1회/월",
      "아티스트 인증 배지",
    ],
    limits: ["고급 통계 분석 불가", "팬미팅 연동 불가"],
    cta: "스타터 시작",
    ctaLink: "/signup?plan=artist-starter",
    highlight: "아티스트 페이지 생성 포함",
  },
  {
    id: "artist-pro",
    name: "Pro",
    nameKo: "프로",
    price: 79900,
    color: "#ff6eb4",
    gradient: "from-[#ff6eb4]/15 to-transparent",
    border: "border-[#ff6eb4]/45",
    badge: "추천" as string | null,
    questLimit: 10,
    questLabel: "월 10개 캠페인 생성",
    features: [
      "아티스트 공식 프로필 페이지 생성",
      "월 10개 캠페인 출제",
      "IP 이미지 최대 12종 등록",
      "팬 제출 영상 열람 + 다운로드",
      "상세 팬 참여 통계 & 분석",
      "커뮤니티 공지 무제한",
      "아티스트 인증 배지",
      "캠페인 보상 커스터마이징",
      "팬 랭킹 & 리더보드 관리",
      "우선 노출 (홈 피처드)",
    ],
    limits: [],
    cta: "Pro 플랜 시작",
    ctaLink: "/signup?plan=artist-pro",
    highlight: "아티스트 페이지 + 캠페인 생성",
  },
  {
    id: "artist-label",
    name: "Label",
    nameKo: "레이블",
    price: 199900,
    color: "#c77dff",
    gradient: "from-[#c77dff]/12 to-transparent",
    border: "border-[#c77dff]/35",
    badge: "엔터프라이즈" as string | null,
    questLimit: 999,
    questLabel: "캠페인 무제한 생성",
    features: [
      "소속 아티스트 최대 10명 관리",
      "아티스트별 공식 프로필 페이지",
      "캠페인 무제한 출제",
      "IP 이미지 무제한 등록",
      "팬 제출 영상 전체 관리",
      "고급 분석 대시보드",
      "팬미팅 / 이벤트 연동",
      "전담 매니저 배정",
      "API 연동 지원",
      "커스텀 브랜딩",
    ],
    limits: [],
    cta: "레이블 문의하기",
    ctaLink: "/signup?plan=artist-label",
    highlight: "다수 아티스트 통합 관리",
  },
];

const tokenPacks = [
  { tokens: 10, price: "₩1,500", priceNum: 1500, bonus: 0, popular: false, color: "#aaaaaa" },
  { tokens: 50, price: "₩6,500", priceNum: 6500, bonus: 5, popular: false, color: "#ff6eb4" },
  { tokens: 120, price: "₩14,000", priceNum: 14000, bonus: 20, popular: true, color: "#ffd60a" },
  { tokens: 300, price: "₩30,000", priceNum: 30000, bonus: 60, popular: false, color: "#4fc3f7" },
];

const fanFaqs = [
  { q: "토큰은 어떻게 사용하나요?", a: "AI 영상 생성 1회당 토큰이 소모됩니다. 영상 길이와 해상도에 따라 1~5 토큰이 사용됩니다. 15초 기본 영상은 1 토큰, 30초 고화질 영상은 3~5 토큰이 소모됩니다." },
  { q: "구독을 취소하면 토큰은 어떻게 되나요?", a: "구독 취소 시 해당 월 말까지 토큰을 사용할 수 있습니다. 단, 무료 플랜으로 전환 시 이월 가능한 토큰은 최대 10개까지만 유지됩니다." },
  { q: "토큰 팩은 구독과 별도로 구매 가능한가요?", a: "네, 토큰 팩은 구독 플랜과 무관하게 별도 구매 가능합니다. 구매한 토큰은 만료 기간 없이 사용할 수 있습니다." },
  { q: "아이돌 IP는 어떻게 활용하나요?", a: "플랜에 따라 접근 가능한 아이돌 IP가 다릅니다. 팬 플랜 이상부터 모든 아이돌 IP를 활용할 수 있으며, 슈퍼팬 플랜은 독점 IP와 신규 IP 얼리 액세스가 제공됩니다." },
];

const artistFaqs = [
  { q: "아티스트 프로필 페이지는 어떻게 생성되나요?", a: "플랜 구독 후 아티스트 대시보드에서 프로필 정보, IP 이미지, 소개글 등을 직접 입력하면 즉시 공개 프로필 페이지가 생성됩니다. 별도 심사 없이 바로 활성화됩니다." },
  { q: "캠페인은 어떻게 출제하나요?", a: "아티스트 대시보드의 '캠페인 만들기' 메뉴에서 캠페인 유형(뮤직비디오 신/안무/챌린지), 미션 내용, 보상 XP, 마감일을 설정하면 즉시 팬들에게 공개됩니다." },
  { q: "팬들이 제출한 영상은 어떻게 관리하나요?", a: "아티스트 대시보드에서 팬 제출 영상을 모두 열람할 수 있습니다. Pro 플랜 이상은 영상 다운로드 및 에디터 픽 직접 선정 기능이 제공됩니다." },
  { q: "레이블 플랜은 여러 아티스트를 관리할 수 있나요?", a: "네, 레이블 플랜은 소속 아티스트 최대 10명을 하나의 계정으로 통합 관리할 수 있습니다. 아티스트별 개별 프로필 페이지와 캠페인 관리가 가능합니다." },
];

export default function PricingPage() {
  const [activeTab, setActiveTab] = useState<TabType>("fan");
  const [billingCycle, setBillingCycle] = useState<"monthly" | "yearly">("monthly");
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [selectedToken, setSelectedToken] = useState<number | null>(null);

  const getPrice = (price: number) =>
    billingCycle === "yearly" ? Math.floor(price * 0.8) : price;

  const currentFaqs = activeTab === "fan" ? fanFaqs : artistFaqs;

  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white">
      <Navbar />

      {/* Hero */}
      <div className="relative pt-28 pb-14 px-6 text-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/7e62a7d80f56ceba0f9bf9a24387cfa1.jpg"
            alt="Pricing Hero"
            className="w-full h-full object-cover object-top opacity-15"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0f]/60 to-[#0a0a0f]" />
        </div>
        <div className="relative z-10 max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-6 h-6 flex items-center justify-center rounded-full bg-gradient-to-r from-[#ff6eb4] to-[#4fc3f7]">
              <i className="ri-vip-crown-fill text-white text-xs" />
            </span>
            <span className="text-[#ff6eb4] text-xs font-semibold tracking-widest uppercase">Pricing</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-black text-white mb-4 leading-tight">
            팬과 크리에이터 모두를 위한<br />
            <span className="bg-gradient-to-r from-[#ff6eb4] to-[#ff8c42] bg-clip-text text-transparent">CreatorVerse 요금제</span>
          </h1>
          <p className="text-white/50 text-base mb-8">
            팬은 AI 토큰으로 K-POP, 드라마, 영화, 웹툰 창작물을 제작하고, 크리에이터는 공식 페이지와 퀘스트를 운영하세요.
          </p>

          {/* Tab Switcher */}
          <div className="inline-flex items-center gap-1 bg-white/5 border border-white/10 rounded-full px-1 py-1 mb-6">
            <button
              onClick={() => { setActiveTab("fan"); setOpenFaq(null); }}
              className={`px-6 py-2.5 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 ${
                activeTab === "fan" ? "bg-gradient-to-r from-[#ff6eb4] to-[#ff6eb4]/80 text-white" : "text-white/40 hover:text-white/70"
              }`}
            >
              <i className="ri-user-heart-line" />
              팬 플랜
            </button>
            <button
              onClick={() => { setActiveTab("artist"); setOpenFaq(null); }}
              className={`px-6 py-2.5 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 ${
                activeTab === "artist" ? "bg-gradient-to-r from-[#ffd60a] to-[#ffd60a]/80 text-[#0a0a0f]" : "text-white/40 hover:text-white/70"
              }`}
            >
              <i className="ri-user-star-line" />
              아티스트 플랜
            </button>
          </div>

          {/* Billing Toggle */}
          <div className="flex justify-center">
            <div className="inline-flex items-center gap-1 bg-white/5 border border-white/10 rounded-full px-1 py-1">
              <button
                onClick={() => setBillingCycle("monthly")}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                  billingCycle === "monthly" ? "bg-white/15 text-white" : "text-white/40 hover:text-white/70"
                }`}
              >
                월간 결제
              </button>
              <button
                onClick={() => setBillingCycle("yearly")}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 ${
                  billingCycle === "yearly" ? "bg-white/15 text-white" : "text-white/40 hover:text-white/70"
                }`}
              >
                연간 결제
                <span className="px-2 py-0.5 rounded-full text-[10px] font-bold bg-[#ff6eb4]/20 text-[#ff6eb4]">20% 할인</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 pb-20">

        {/* ── 팬 플랜 ── */}
        {activeTab === "fan" && (
          <>
            {/* Fan Plans */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
              {fanPlans.map((plan) => (
                <div
                  key={plan.id}
                  className={`relative rounded-2xl border bg-gradient-to-b ${plan.gradient} bg-[#0f0f1a] p-7 flex flex-col ${plan.border} ${plan.badge === "인기" ? "scale-[1.03]" : ""}`}
                >
                  {plan.badge && (
                    <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full text-xs font-bold text-white"
                      style={{ background: `linear-gradient(135deg, ${plan.color}, ${plan.color}99)` }}>
                      {plan.badge}
                    </div>
                  )}
                  <div className="mb-6">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-white font-black text-xl">{plan.name}</span>
                      <span className="text-white/40 text-sm">({plan.nameKo})</span>
                    </div>
                    <div className="flex items-end gap-1 mb-1">
                      <span className="text-3xl font-black text-white">
                        {plan.price === 0 ? "₩0" : `₩${getPrice(plan.price).toLocaleString()}`}
                      </span>
                      {plan.price > 0 && <span className="text-white/40 text-sm mb-1">/ 월</span>}
                    </div>
                    {billingCycle === "yearly" && plan.price > 0 && (
                      <p className="text-[#ff6eb4] text-xs">연간 결제 시 20% 할인</p>
                    )}
                    {plan.price === 0 && <p className="text-white/40 text-sm">영구 무료</p>}
                  </div>

                  {/* Token Box */}
                  <div className="rounded-xl p-4 mb-6 flex items-center gap-3"
                    style={{ background: `${plan.color}12`, border: `1px solid ${plan.color}30` }}>
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0" style={{ background: `${plan.color}20` }}>
                      <i className="ri-coin-fill text-xl" style={{ color: plan.color }} />
                    </div>
                    <div>
                      <div className="font-black text-lg" style={{ color: plan.color }}>{plan.tokenLabel}</div>
                      <div className="text-white/40 text-xs">AI 영상 생성에 사용</div>
                    </div>
                  </div>

                  <ul className="flex flex-col gap-2.5 mb-6 flex-1">
                    {plan.features.map((f) => (
                      <li key={f} className="flex items-start gap-2.5 text-sm text-white/70">
                        <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-check-line text-xs" style={{ color: plan.color }} />
                        </div>
                        {f}
                      </li>
                    ))}
                    {plan.limits.map((l) => (
                      <li key={l} className="flex items-start gap-2.5 text-sm text-white/25">
                        <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-close-line text-xs text-white/20" />
                        </div>
                        {l}
                      </li>
                    ))}
                  </ul>

                  <Link to={plan.ctaLink}
                    className="w-full py-3.5 rounded-xl font-bold text-sm text-center transition-all cursor-pointer whitespace-nowrap block"
                    style={plan.price === 0
                      ? { border: "1px solid rgba(255,255,255,0.2)", color: "rgba(255,255,255,0.7)" }
                      : { background: `linear-gradient(135deg, ${plan.color}, ${plan.color}bb)`, color: plan.id === "fan" ? "#0a0a0f" : "white" }
                    }>
                    {plan.cta}
                  </Link>
                </div>
              ))}
            </div>

            {/* Token Pack */}
            <div className="mb-16">
              <div className="text-center mb-8">
                <div className="flex items-center justify-center gap-2 mb-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-gradient-to-r from-[#ffd60a] to-[#ff6eb4]">
                    <i className="ri-coin-fill text-white text-xs" />
                  </span>
                  <span className="text-[#ffd60a] text-xs font-semibold tracking-widest uppercase">Token Packs</span>
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-white mb-2">
                  토큰이 부족하다면?{" "}
                  <span className="bg-gradient-to-r from-[#ffd60a] to-[#ff6eb4] bg-clip-text text-transparent">추가 토큰 팩 구매</span>
                </h2>
                <p className="text-white/40 text-sm">구독 플랜과 별도로 언제든지 추가 구매 가능. 구매한 토큰은 만료 없이 사용 가능.</p>
              </div>
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                {tokenPacks.map((pack, idx) => (
                  <button key={idx} onClick={() => setSelectedToken(idx)}
                    className={`relative rounded-2xl border p-5 text-left transition-all duration-200 cursor-pointer ${
                      selectedToken === idx ? "border-[#ffd60a]/60 bg-[#ffd60a]/8" : "border-white/10 bg-white/5 hover:border-white/20"
                    }`}>
                    {pack.popular && (
                      <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 px-3 py-0.5 rounded-full text-[10px] font-bold bg-[#ffd60a] text-[#0a0a0f]">베스트</div>
                    )}
                    <div className="flex items-center gap-2 mb-3">
                      <div className="w-8 h-8 flex items-center justify-center rounded-lg" style={{ background: `${pack.color}18` }}>
                        <i className="ri-coin-fill text-sm" style={{ color: pack.color }} />
                      </div>
                      <span className="text-white font-black text-lg">{pack.tokens}</span>
                      <span className="text-white/40 text-sm">토큰</span>
                    </div>
                    {pack.bonus > 0 && <div className="text-[#ffd60a] text-xs font-semibold mb-2">+{pack.bonus} 보너스 토큰</div>}
                    <div className="text-white font-bold text-base">{pack.price}</div>
                    <div className="text-white/30 text-xs mt-0.5">≈ {pack.tokens + pack.bonus}회 AI 생성</div>
                    {selectedToken === idx && (
                      <div className="absolute top-3 right-3 w-5 h-5 flex items-center justify-center rounded-full bg-[#ffd60a]">
                        <i className="ri-check-line text-[#0a0a0f] text-xs" />
                      </div>
                    )}
                  </button>
                ))}
              </div>
              {selectedToken !== null && (
                <div className="mt-5 flex justify-center">
                  <Link to="/signup"
                    className="px-8 py-3 rounded-full bg-gradient-to-r from-[#ffd60a] to-[#ff6eb4] text-white font-bold text-sm cursor-pointer whitespace-nowrap hover:opacity-90 transition-opacity">
                    <i className="ri-coin-line mr-2" />
                    {tokenPacks[selectedToken].tokens + tokenPacks[selectedToken].bonus}토큰 구매하기 — {tokenPacks[selectedToken].price}
                  </Link>
                </div>
              )}
            </div>

            {/* Token Usage Guide */}
            <div className="rounded-2xl border border-white/10 bg-white/3 p-8 mb-16">
              <h3 className="text-white font-bold text-lg mb-6 text-center">토큰 사용 가이드</h3>
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
                {[
                  { icon: "ri-film-line", color: "#ff6eb4", title: "기본 MV 신", tokens: "1 토큰", desc: "15초 이하, 720p" },
                  { icon: "ri-music-2-line", color: "#4fc3f7", title: "안무 영상", tokens: "2 토큰", desc: "15초, 1080p" },
                  { icon: "ri-hd-line", color: "#ffd60a", title: "HD MV 신", tokens: "3 토큰", desc: "30초, 1080p" },
                  { icon: "ri-4k-line", color: "#c77dff", title: "4K 풀 영상", tokens: "5 토큰", desc: "30초, 4K (슈퍼팬 전용)" },
                ].map((item) => (
                  <div key={item.title} className="text-center">
                    <div className="w-12 h-12 flex items-center justify-center rounded-xl mx-auto mb-3"
                      style={{ background: `${item.color}15`, border: `1px solid ${item.color}30` }}>
                      <i className={`${item.icon} text-xl`} style={{ color: item.color }} />
                    </div>
                    <div className="text-white font-bold text-sm mb-1">{item.title}</div>
                    <div className="font-black text-lg mb-1" style={{ color: item.color }}>{item.tokens}</div>
                    <div className="text-white/40 text-xs">{item.desc}</div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}

        {/* ── 아티스트 플랜 ── */}
        {activeTab === "artist" && (
          <>
            {/* Artist Plan Intro */}
            <div className="text-center mb-10">
              <p className="text-white/50 text-sm max-w-xl mx-auto leading-relaxed">
                아티스트 플랜은 공식 아티스트 프로필 페이지 생성과 팬 퀘스트 출제 기능을 제공합니다.<br />
                팬들과 함께 뮤직비디오 신과 안무를 만들어가세요.
              </p>
            </div>

            {/* Artist Plans */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
              {artistPlans.map((plan) => (
                <div
                  key={plan.id}
                  className={`relative rounded-2xl border bg-gradient-to-b ${plan.gradient} bg-[#0f0f1a] p-7 flex flex-col ${plan.border} ${plan.badge === "추천" ? "scale-[1.03]" : ""}`}
                >
                  {plan.badge && (
                    <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full text-xs font-bold"
                      style={{ background: `linear-gradient(135deg, ${plan.color}, ${plan.color}99)`, color: plan.id === "artist-starter" ? "#0a0a0f" : "white" }}>
                      {plan.badge}
                    </div>
                  )}

                  <div className="mb-5">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-white font-black text-xl">{plan.name}</span>
                      <span className="text-white/40 text-sm">({plan.nameKo})</span>
                    </div>
                    <div className="flex items-end gap-1 mb-1">
                      <span className="text-3xl font-black text-white">
                        ₩{getPrice(plan.price).toLocaleString()}
                      </span>
                      <span className="text-white/40 text-sm mb-1">/ 월</span>
                    </div>
                    {billingCycle === "yearly" && (
                      <p className="text-[#ffd60a] text-xs">연간 결제 시 20% 할인</p>
                    )}
                  </div>

                  {/* Quest Limit Box */}
                  <div className="rounded-xl p-4 mb-5 flex items-center gap-3"
                    style={{ background: `${plan.color}12`, border: `1px solid ${plan.color}30` }}>
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0" style={{ background: `${plan.color}20` }}>
                      <i className="ri-film-line text-xl" style={{ color: plan.color }} />
                    </div>
                    <div>
                      <div className="font-black text-base leading-tight" style={{ color: plan.color }}>{plan.questLabel}</div>
                      <div className="text-white/40 text-xs mt-0.5">팬 퀘스트 출제</div>
                    </div>
                  </div>

                  {/* Highlight Badge */}
                  <div className="flex items-center gap-2 mb-4 px-3 py-2 rounded-lg"
                    style={{ background: `${plan.color}10`, border: `1px solid ${plan.color}20` }}>
                    <i className="ri-star-line text-xs flex-shrink-0" style={{ color: plan.color }} />
                    <span className="text-xs font-semibold" style={{ color: plan.color }}>{plan.highlight}</span>
                  </div>

                  <ul className="flex flex-col gap-2.5 mb-6 flex-1">
                    {plan.features.map((f) => (
                      <li key={f} className="flex items-start gap-2.5 text-sm text-white/70">
                        <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-check-line text-xs" style={{ color: plan.color }} />
                        </div>
                        {f}
                      </li>
                    ))}
                    {plan.limits.map((l) => (
                      <li key={l} className="flex items-start gap-2.5 text-sm text-white/25">
                        <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-close-line text-xs text-white/20" />
                        </div>
                        {l}
                      </li>
                    ))}
                  </ul>

                  <Link to={plan.ctaLink}
                    className="w-full py-3.5 rounded-xl font-bold text-sm text-center transition-all cursor-pointer whitespace-nowrap block hover:opacity-90"
                    style={{
                      background: `linear-gradient(135deg, ${plan.color}, ${plan.color}bb)`,
                      color: plan.id === "artist-starter" ? "#0a0a0f" : "white",
                    }}>
                    {plan.cta}
                  </Link>
                </div>
              ))}
            </div>

            {/* Artist Feature Comparison */}
            <div className="rounded-2xl border border-white/10 bg-white/3 p-8 mb-16">
              <h3 className="text-white font-bold text-lg mb-8 text-center">아티스트 플랜 핵심 기능</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {[
                  { icon: "ri-user-star-line", color: "#ffd60a", title: "공식 프로필 페이지", desc: "아티스트 전용 공개 프로필 페이지 즉시 생성. IP 이미지, 소개, 소셜 링크 포함." },
                  { icon: "ri-film-line", color: "#ff6eb4", title: "캠페인 출제", desc: "뮤직비디오 신, 안무, 챌린지 등 다양한 캠페인을 직접 출제하고 팬 참여를 유도하세요." },
                  { icon: "ri-bar-chart-line", color: "#4fc3f7", title: "팬 참여 통계", desc: "캠페인별 참여 현황, 제출 영상 수, 팬 활동 지표를 실시간으로 확인하세요." },
                  { icon: "ri-trophy-line", color: "#c77dff", title: "보상 커스터마이징", desc: "XP 보상, 배지, 팬미팅 추첨 등 다양한 보상 정책을 직접 설정할 수 있습니다." },
                ].map((item) => (
                  <div key={item.title} className="text-center">
                    <div className="w-14 h-14 flex items-center justify-center rounded-2xl mx-auto mb-4"
                      style={{ background: `${item.color}15`, border: `1px solid ${item.color}30` }}>
                      <i className={`${item.icon} text-2xl`} style={{ color: item.color }} />
                    </div>
                    <h4 className="text-white font-bold text-sm mb-2">{item.title}</h4>
                    <p className="text-white/40 text-xs leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Plan Comparison Table */}
            <div className="rounded-2xl border border-white/10 bg-white/3 overflow-hidden mb-16">
              <div className="p-6 border-b border-white/10">
                <h3 className="text-white font-bold text-lg">플랜 상세 비교</h3>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="border-b border-white/10">
                      <th className="text-left px-6 py-4 text-white/40 text-xs font-semibold uppercase tracking-wider w-1/3">기능</th>
                      {artistPlans.map((p) => (
                        <th key={p.id} className="px-6 py-4 text-center">
                          <span className="font-black text-sm" style={{ color: p.color }}>{p.name}</span>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { label: "아티스트 프로필 페이지", values: ["✓", "✓", "✓"] },
                      { label: "월 캠페인 출제 수", values: ["3개", "10개", "무제한"] },
                      { label: "IP 이미지 등록", values: ["4종", "12종", "무제한"] },
                      { label: "팬 제출 영상 다운로드", values: ["✗", "✓", "✓"] },
                      { label: "상세 통계 분석", values: ["기본", "상세", "고급"] },
                      { label: "팬미팅 이벤트 연동", values: ["✗", "✗", "✓"] },
                      { label: "다수 아티스트 관리", values: ["✗", "✗", "최대 10명"] },
                      { label: "전담 매니저", values: ["✗", "✗", "✓"] },
                    ].map((row, i) => (
                      <tr key={row.label} className={`border-b border-white/5 ${i % 2 === 0 ? "bg-white/2" : ""}`}>
                        <td className="px-6 py-3.5 text-white/60 text-sm">{row.label}</td>
                        {row.values.map((v, vi) => (
                          <td key={vi} className="px-6 py-3.5 text-center text-sm">
                            {v === "✓" ? (
                              <i className="ri-check-line" style={{ color: artistPlans[vi].color }} />
                            ) : v === "✗" ? (
                              <i className="ri-close-line text-white/20" />
                            ) : (
                              <span className="font-semibold" style={{ color: artistPlans[vi].color }}>{v}</span>
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}

        {/* FAQ */}
        <div className="max-w-2xl mx-auto">
          <h3 className="text-white font-bold text-xl mb-6 text-center">
            {activeTab === "fan" ? "팬 플랜" : "아티스트 플랜"} 자주 묻는 질문
          </h3>
          <div className="flex flex-col gap-3">
            {currentFaqs.map((faq, idx) => (
              <div key={idx} className="rounded-xl border border-white/10 bg-white/5 overflow-hidden">
                <button
                  onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                >
                  <span className="text-white font-medium text-sm">{faq.q}</span>
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 ml-3">
                    <i className={`text-white/40 text-sm ${openFaq === idx ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}`} />
                  </div>
                </button>
                {openFaq === idx && (
                  <div className="px-5 pb-4">
                    <p className="text-white/50 text-sm leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 relative rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=kpop%20idol%20group%20stage%20performance%2C%20colorful%20concert%20lighting%2C%20fan%20light%20sticks%2C%20wide%20panoramic%20banner%2C%20pink%20and%20blue%20atmosphere&width=1400&height=250&seq=pricing-cta-banner-001&orientation=landscape"
            alt="CTA"
            className="w-full h-44 object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/85" />
          <div className="absolute inset-0 flex flex-col md:flex-row items-center justify-between px-8 md:px-12 gap-4">
            <div>
              <h3 className="text-white font-bold text-xl md:text-2xl mb-1">
                {activeTab === "fan" ? "지금 바로 팬 크리에이터가 되세요" : "아티스트 페이지를 지금 만들어보세요"}
              </h3>
              <p className="text-white/60 text-sm">
                {activeTab === "fan" ? "좋아하는 아이돌의 뮤직비디오 신을 AI로 직접 제작하세요" : "팬들과 함께 퀘스트를 운영하고 창작 생태계를 만들어가세요"}
              </p>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
              <Link to={activeTab === "fan" ? "/signup?plan=fan" : "/signup?plan=artist-pro"}
                className="px-6 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
                style={{ background: activeTab === "fan" ? "linear-gradient(135deg, #ff6eb4, #4fc3f7)" : "linear-gradient(135deg, #ffd60a, #ff6eb4)", color: activeTab === "fan" ? "white" : "#0a0a0f" }}>
                {activeTab === "fan" ? "팬 플랜 시작" : "아티스트 플랜 시작"}
              </Link>
              <Link to="/pricing"
                className="px-6 py-2.5 rounded-full border border-white/30 text-white text-sm font-medium whitespace-nowrap cursor-pointer hover:border-white/60 transition-colors"
                onClick={() => setActiveTab(activeTab === "fan" ? "artist" : "fan")}>
                {activeTab === "fan" ? "아티스트 플랜 보기" : "팬 플랜 보기"}
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
